import React from 'react';
import { Box, Skeleton, Container } from '@mui/material';

const LayoutSkeleton = () => {
    return (
        <Box sx={{ py: 8, bgcolor: 'background.paper' }}>
            <Container>
                {/* Title Section */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 6 }}>
                    <Skeleton
                        variant="text"
                        sx={{
                            fontSize: { xs: "32px", md: "56px" },
                            width: { xs: "80%", md: "40%" },
                            bgcolor: "grey.200"
                        }}
                    />
                    <Skeleton
                        variant="text"
                        sx={{
                            fontSize: "16px",
                            width: { xs: "60%", md: "30%" },
                            mt: 1,
                            bgcolor: "grey.100"
                        }}
                    />
                </Box>

                {/* Grid Section */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "repeat(2, 1fr)",
                            sm: "repeat(2, 1fr)",
                            md: "repeat(4, 1fr)",
                        },
                        gap: 4,
                    }}
                >
                    {Array.from(new Array(4)).map((_, index) => (
                        <Box key={index} sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Skeleton
                                variant="rectangular"
                                height={300}
                                sx={{
                                    borderRadius: 3,
                                    mb: 2,
                                    bgcolor: "grey.200"
                                }}
                            />
                            <Skeleton
                                variant="text"
                                width="80%"
                                height={32}
                                sx={{ bgcolor: "grey.200" }}
                            />
                            <Skeleton
                                variant="text"
                                width="40%"
                                height={24}
                                sx={{ mt: 0.5, bgcolor: "grey.100" }}
                            />
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default LayoutSkeleton;
